/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import store from "@/assets/js/store.js";
import GLOBAL from '@/assets/js/global.js';
import { issn , token_type , url_dev , url_production } from './config.js';

//ajxa_map
let ajax_url_map = GLOBAL.ajax_url_map;

/*请求合并只出现一次loading*/
let needLoadingRequestCount = 0

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    loading('start')/*loading加载*/
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    setTimeout(tryCloseLoading,300)/*300ms 间隔内的 loading 合并为一次*/
  }
}

const tryCloseLoading = () => {
  if (needLoadingRequestCount === 0) {
    loading('end')/*loading加载*/
  }
}

/*loading加载*/
function loading (str){
    if(str =='start'){
        store.commit('$_setLoading',true);
    }else if(str=='end'){
        store.commit('$_setLoading',false);
    }
}

// 环境的切换
if (process.env.NODE_ENV == 'development') {    
    axios.defaults.baseURL = url_dev;
} else if (process.env.NODE_ENV == 'debug') {    
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {    
    axios.defaults.baseURL = url_production;
}

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json';

// 请求拦截器
axios.interceptors.request.use(    
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        config.headers.Authorization = store.state.token;

        if (config.url != ajax_url_map.tips) {
            config.headers["issn"] = issn;
            showFullScreenLoading();
        }

        if (config.url == ajax_url_map.invite_cut || config.url == ajax_url_map.task_share) {
            config.headers["link"] = GLOBAL.domain.indexOf('http')< 0 ? 'https:' + GLOBAL.domain : GLOBAL.domain;
        }    
        return config;
    },    
    error => {        
        return Promise.error(error);    
    })

// 响应拦截器
axios.interceptors.response.use(    
    response => {      
        tryHideFullScreenLoading();  
        if(response.data.code == 0){
            //speciel
            return Promise.resolve(response.data); //进行中
        }
        else if(response.data.code == 401){//未登录
            localStorage.removeItem(token_type);
            localStorage.removeItem('account');
            localStorage.removeItem('userinfo');
            store.commit("$_setLogin", 0);
            store.commit("$_setUserinfo", {});
            store.commit("$_setAccount", {});            
            return Promise.reject(response.data);
        }
        else {            
            return Promise.reject(response.data);        
        }    
    },
    // 服务器状态码不是200的情况    
    error => { 
        tryHideFullScreenLoading();      
        if (error.response.status) {            
            switch (error.response.status) {                
                // 401: 未登录                
                // 未登录则跳转登录页面，并携带当前页面的路径                
                // 在登录成功后返回当前页面，这一步需要在登录页操作。                
                case 401:                    
                    localStorage.removeItem(token_type);
                    localStorage.removeItem('account');
                    localStorage.removeItem('userinfo');
                    store.commit("$_setLogin", 0);
                    store.commit("$_setUserinfo", {});
                    store.commit("$_setAccount", {});   
                    break;
                // 403 token过期                
                // 登录过期对用户进行提示                
                // 清除本地token和清空vuex中token对象                
                // 跳转登录页面                
                case 403:
                    console.log('登录过期，请重新登录');                                     
                    // 清除token                    
                    localStorage.removeItem(token_type);                    

                    setTimeout(() => {                        
                        //todo reflash
                        document.location = GLOBAL.domain;                   
                    }, 1000);                    
                    break; 
                // 404请求不存在                
                case 404:                    
                    console.log('网络请求不存在');                
                break;                
                // 其他错误，直接抛出错误提示                
                default:  
                    console.log(error.response.data.message);                                 
            }            
            return Promise.reject(error.response);        
        }       
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params){    
    return new Promise((resolve, reject) =>{        
        axios.get(url, {            
            params: params        
        })        
        .then(res => {            
            resolve(res);        
        })        
        .catch(err => {            
            reject(err)        
        })    
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {    
    return new Promise((resolve, reject) => {         
        axios.post(url, params)        
        .then(res => {            
            resolve(res);        
        })        
        .catch(err => {            
            reject(err)        
        })    
    });
}